import React, { useCallback, useEffect, useState} from 'react';
import { Grid, GridContainer } from 'src/shared/grid';
import { Link } from "react-router-dom";
import { ROUTE_PATHS } from 'src/routes/paths';
import { Button, FormControlLabel, IconButton, Switch } from '@mui/material';
import { useStoreContext } from 'src/store/context';
import { checkAdminRole, errorResponse } from 'src/store/common';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import { deleteModalStyle, modalStyle } from 'src/shared/Styles/Styles';
import { AddReport } from './AddReport';
import { DeleteReportModal } from './DeleteReportModal';
import { useAddAlert } from 'src/store/actions';
import { alertMessages } from 'src/constants';
import { createUpdateReport, getReports } from 'src/apis/mutationsReports';

type TabProps = {
    tab: number;
    name: string;
    id:string;
}
export const ReportsTab: React.FC<TabProps> = ({tab, name,id}) =>{
    const [reports, setReports] = useState<any[]>([]);
    const [state, dispatch] = useStoreContext();

    const [openReportModal, setOpenReportModal] = useState<boolean>(false);
    const [createUpdateReportSuccess, setCreateUpdateReportSuccess] = useState<boolean>(false);
    const [editReport, setEditReport] = useState<string>('');
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [deleteReport, setDeleteReport] = useState<string>('');
    const addAlert = useAddAlert(dispatch);
    const [deleteReportSuccess, setDeleteReportSuccess] = useState<boolean>(false);

    const getReportsForType = useCallback((isVisible: string) => {
        (async () => {
            try {
                const varRequest = {
                    sortBy: 'title',
                    sortOrder: 'asc',
                    page: 0,
                    perPage: 1000,
                    type: id,
                    visible: isVisible
                };
                const response: any = await getReports(varRequest, addAlert);
                if (response) {
                    setReports(response)
                }
                else{
                    setReports([])
                }
                setCreateUpdateReportSuccess(false)
                setDeleteReportSuccess(false)
            }
            catch (error) {
                setReports([])
                setCreateUpdateReportSuccess(false)
                setDeleteReportSuccess(false)
                addAlert({
                    id: '',
                    message: alertMessages.reportGet,
                    type: 'error-info',
                    icon: 'fa-exclamation-triangle'
                })
            }
        })();
    }, [addAlert,id,]);


    useEffect(()=>{
        state.user && checkAdminRole(state.user)?
            getReportsForType('ALL'): getReportsForType('TRUE');    
    }, [getReportsForType, state.user]);

    useEffect(()=>{
        if(createUpdateReportSuccess || deleteReportSuccess){
            state.user && checkAdminRole(state.user)?
            getReportsForType('ALL'): getReportsForType('TRUE');   

        }
    },[getReportsForType, createUpdateReportSuccess, deleteReportSuccess, state.user])

    const getLinkToReport = (report: any) => {
        return { pathname: `${ROUTE_PATHS.report}${id}/${report.id}`, state: { ...report } }
    }

    const handleCloseReportModal = (_event: any, reason: any) => {
        if (reason && reason === "backdropClick") {
            setEditReport('')
            setOpenReportModal(false);
        }
        setOpenReportModal(false);
        setEditReport('')
    }

    const handleEditReport =(e:any, id)=>{
        setEditReport(id)
        setOpenReportModal(true)
    }
    const handleDeleteReport =(e:any, id)=>{
        setDeleteReport(id)
        setOpenDeleteModal(true)
    }

    const handleCloseDelete = (event, reason) => {
        if (reason && reason === "backdropClick")
            return;
        setOpenDeleteModal(false);
        setDeleteReport('')

    }

    const findType = (type:string)=>{
        if(type==='Advanced Analytics'){
            return 'advanced_analytics'
        }
        if(type==='Field Sample'){
            return 'field_sample'
        }
        if(type==='NFDRS'){
            return 'nfdrs'
        }
        if(type==='Weather'){
            return 'weather'
        }
        if(type==='Station Information'){
            return 'station_information'
        }
    }
    const handleVisibleUpdate = (event: any, values: any) => {
        (async () => {
            try {
                const paramsToSend = {
                    id: values.id,
                    title: values.title,
                    description: values.description,
                    type: findType(values.type),
                    url: values.url,
                    visible: event.target.checked
                }
                const response: any = await createUpdateReport(paramsToSend, addAlert);
                if (response?.data.data.createUpdatePowerBIReport.message?.length > 0) {
                    setCreateUpdateReportSuccess(true)
                    //save banner
                    if (values.reportId === null) {
                        errorResponse('', addAlert, `The report, ${response.data.data.createUpdatePowerBIReport.data.title}, was saved.`, true);
                    }
                    else {
                        errorResponse('', addAlert, `The changes to the report, ${response.data.data.createUpdatePowerBIReport.data.title}, was saved.`, true);
                    }

                }
            }
            catch (error: any) {
                console.log('error', error);
                addAlert({
                    id: '',
                    message: alertMessages.report,
                    type: 'error-info',
                    icon: 'fa-exclamation-triangle'
                })
            }
        })();
    }

    return (
        <GridContainer className="margin-top-6">
            <Modal //Modal to open edit/create report
                className="smooth-scrollbar"
                open={openReportModal}
                onClose={handleCloseReportModal}
            >
                <div>
                    <IconButton aria-label='close' style={{ left: '73.5%', top: '5.5%', position: 'absolute', cursor: 'pointer' }} onClick={() => { setOpenReportModal(false) }}>
                        <CloseIcon style={{ color: 'white' }} />
                    </IconButton>
                    <Box sx={modalStyle} className="smooth-scrollbar removePadding" >
                        {
                            <AddReport setOpen={setOpenReportModal} typeFromParam={id} setCreateUpdateReportSuccess={setCreateUpdateReportSuccess} editReport={editReport}/>
                        }
                    </Box>
                </div>
            </Modal>
            <Modal
                className="smooth-scrollbar"
                open={openDeleteModal}
                onClose={handleCloseDelete}
            >
                <div style={{ height: '100%' }}>
                <IconButton aria-label='close' style={{ left: '64%', top: '23.5%', position: 'absolute', cursor: 'pointer' }} onClick={(e)=>handleCloseDelete(e,'click')} >
                    <CloseIcon style={{ color: 'white' }} />
                </IconButton>
                <Box sx={deleteModalStyle} className="smooth-scrollbar removePadding">
                    <DeleteReportModal setDeleteReportSuccess={setDeleteReportSuccess} setOpenDeleteModal={setOpenDeleteModal} setDeleteReport={setDeleteReport} deleteReportId={deleteReport}/>
                </Box>
                </div>
            </Modal>

            {
                state.user && checkAdminRole(state.user) &&

                <Grid row gap='md' className='padding-bottom-2'>
                    <Grid 
                    desktop={{col:10}}
                    />
                <Grid 
                    desktop={{col:2}}
                    >
                        <Button
                            variant="contained"
                            onClick={()=> {setOpenReportModal(true); setEditReport('')}}
                        >
                            Add Report
                        </Button>
                    </Grid>
                </Grid>
            }

            { reports?.length>0 ?
                reports.map((report)=>(
                    <div
                    key={`${report.title}-${report.id}-on`}
                    >
                        <Grid row gap="md"
                          key={`${report.title}-${report.id}---`}
                        >
                            <Grid
                                desktop={{ col: 6}}
                                key={`${report.title}-${report.id}`}
                                className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 padding-top-3"
                            >
                                
                                <Link
                                    to={getLinkToReport(report)}
                                    color="primary"
                                    className="font-sans-lg text-bold"
                                    style={{ fontWeight: 500 }}
                                    key={report.title}
                                >
                                    {report.title}
                                </Link>
                            </Grid>
                            
                            {
                                state.user && checkAdminRole(state.user) &&
                                <>
                                    <Grid
                                        desktop={{ col: 1 }}
                                        key={`${report.title}-${report.id}--button-delete`}
                                        className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 padding-top-3"
                                    >
                                        <Button
                                            variant="contained"
                                            color="error"
                                            key={`${report.id}-delete`}
                                            onClick={(e:any)=> handleDeleteReport(e, report.id)}
                                        >
                                            Delete
                                        </Button>
                                    </Grid>


                                    <Grid
                                        desktop={{ col: 1 }}
                                        key={`${report.title}-${report.id}--button-update`}
                                        className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 padding-top-3"
                                    >
                                        <Button
                                            variant="outlined"
                                            key={`${report.id}-update`}
                                            onClick={(e:any)=> handleEditReport(e, report.id)}
                                        >
                                            Update
                                        </Button>
                                    </Grid>
                                    <Grid
                                        desktop={{ col: 1 }}
                                        key={`${report.title}-${report.id}--button-switch`}
                                        className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 padding-top-3"
                                    >
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={report.visible}
                                                    id={`visible-${report.id}`}
                                                    onChange={(e: any) => {handleVisibleUpdate(e, report)}}
                                                    size="medium"
                                                    color="primary"
                                                    inputProps={{ 'aria-label': 'Visible' }}
                                                />
                                            }
                                            label="Visible"
                                        />

                                    </Grid>

                                </>
                            }
                        </Grid>


                        <Grid row gap="lg" id={'data-sets'} key={`${report.id}-descriptions`} >
                            <Grid desktop={{ col: 12 }} className="padding-bottom-5" key={`${report.id}-descriptions-${report.title}`}>
                               {report.description}
                            </Grid>
                        </Grid>
                    </div>
                ))
                :
                (
                    <div className={'selectedStationTextBox'} style={{ marginTop: '3%', width: '100%' }}>
                        <ul>
                            Reports are currently in development. Please check back at a later time.
                        </ul>
                    </div>
                )
            }
            
        </GridContainer>
    )
}
